module.exports = __webpack_public_path__ + "static/media/busIcon.23d838c7.png";